import { createCollectionLink } from "@/router";
import { RouteName } from "@/router/routeNameEnum";
import { ItemStatus } from "@/services/collection/item";
import { Filter } from "@/services/collection/collectionFilter";
import { ItemStatusUrlString } from "@/services/collection/collectionUrl";
import type { RouteLocationNormalized } from "vue-router";

export const createArchiveLink = () => {
  const filter = new Filter({ itemStatus: ItemStatus.Deleted });
  return createCollectionLink(filter);
};

export const createMyCollectionMarketplaceItemsLink = () => {
  const filter = new Filter({ itemStatus: ItemStatus.OnMarketplace });
  return createCollectionLink(filter);
};

export const createMyCollectionLink = () => {
  const filter = new Filter({ itemStatus: ItemStatus.InMyCollection });
  return createCollectionLink(filter);
};

export const isArchiveRoute = (route: RouteLocationNormalized): boolean => {
  const isCollectionRoute = route.name === RouteName.Collection;
  const isArchiveFilter = route.params.itemStatus === ItemStatusUrlString.Deleted;
  return isCollectionRoute && isArchiveFilter;
};
